import React from 'react';
import isNil from 'lodash/isNil';
import {
  notEmptyString,
} from '@populateui/utils';
import {
  formatTwoDigitDate,
} from 'utils/date';
import NotesIcon from 'core/icons/notes';
import AuthorizationStatusBadge from 'views/EMR/components/Authorizations/StatusBadge';
import {
  useHideUsedAuthorizationStatus,
} from 'pages/Dashboard/pages/Billing/ClaimForm/UsedAuthorizationsContext';
import type {
  AuthorizationOptionProps,
} from 'pages/Dashboard/pages/Billing/ClaimForm/AuthorizationSelector/types';
import {
  formatAllowanceSummary,
  getLatestGroupedAuthorizationRecord,
} from 'pages/Dashboard/pages/Billing/ClaimForm/AuthorizationSelector/utils';

export default function AuthorizationOptionContent({ option }: AuthorizationOptionProps) {
  const hideStatus = useHideUsedAuthorizationStatus(option);
  const latest = getLatestGroupedAuthorizationRecord(option.authorizations);
  const hasNotes = option.authorizations.some((authorization) => (
    notEmptyString(authorization.notes)
  ));
  const allowances = option.authorizations.flatMap((authorization) => authorization.allowances);

  return (
    <div className="grid w-full min-w-0 grid-cols-[minmax(0,1fr)_auto] gap-x-2 gap-y-1 text-xs">
      <div className="flex min-w-0 items-center gap-1">
        <strong className="min-w-0 truncate">
          {option.authorizationNumber}
        </strong>
        {hasNotes && (
          <NotesIcon
            titleAccess="Has notes"
            className="!h-4 !w-4 shrink-0 text-blue-600"
          />
        )}
      </div>
      {!hideStatus && !isNil(option.status) && (
        <AuthorizationStatusBadge
          status={option.status}
          className="self-start shrink-0"
        />
      )}
      {!isNil(latest) && (
        <span className="col-span-2 text-gray-500">
          {formatTwoDigitDate(latest.effectiveDate)} - {formatTwoDigitDate(latest.expirationDate)}
        </span>
      )}
      {allowances.map((allowance) => (
        <span
          key={allowance.patientAuthorizationAllowanceId}
          className="col-span-2 break-words"
        >
          {formatAllowanceSummary(allowance)}
        </span>
      ))}
    </div>
  );
}
